import i18next from 'i18next';
import { NavigationItem } from '../../types';
export abstract class BaseNavigationTransformer {
  public createHelpPopover(label: string, showInProductTutorials = true) {
    return {
      label,
      id: 'Zuora/HelpAndTraining-popover',
      items: [
        {
          label: i18next.t('GlobalNav.Help.SearchHelp'),
          id: 'Zuora/HelpAndTraining-popover-search-help',
          icon: 'search',
          expandable: false,
          divider: showInProductTutorials ? false : true,
          customEvent: 'search-help',
        },
        ...(showInProductTutorials
          ? [
              {
                label: i18next.t('GlobalNav.Help.InProductTutorials'),
                id: 'Zuora/HelpAndTraining-popover-in-product-tutorials',
                icon: 'tutorials',
                expandable: false,
                divider: true,
                customEvent: 'in-product-tutorials',
              },
            ]
          : []),
        {
          label: i18next.t('GlobalNav.Help.ProductDocumentation'),
          id: 'Zuora/HelpAndTraining-popover-knowledge-center',
          icon: 'newWindow',
          newWindow: true,
          href: 'https://knowledgecenter.zuora.com/',
          expandable: false,
        },
        {
          label: i18next.t('GlobalNav.Help.DeveloperCenter'),
          id: 'Zuora/HelpAndTraining-popover-developer-center',
          icon: 'newWindow',
          newWindow: true,
          href: 'https://developer.zuora.com/',
          expandable: false,
        },
        {
          label: i18next.t('GlobalNav.Help.ZuoraCommunity'),
          id: 'Zuora/HelpAndTraining-popover-zuora-community',
          icon: 'newWindow',
          newWindow: true,
          href: 'https://community.zuora.com/',
          expandable: false,
        },
        {
          label: i18next.t('GlobalNav.Help.ReleaseNotes'),
          id: 'Zuora/HelpAndTraining-popover-release-notes',
          icon: 'newWindow',
          newWindow: true,
          href: 'https://knowledgecenter.zuora.com/Releases/Latest_releases',
          expandable: false,
        },
      ] as NavigationItem[],
    };
  }

  public createFeedbackItem(): NavigationItem {
    return {
      label: i18next.t('GlobalNav.Feedback.SubmitFeedback'),
      id: 'Zuora/SubmitFeedback',
      icon: 'feedback',
      highlightIcon: true,
      divider: true,
      popover: {
        label: i18next.t('GlobalNav.Feedback.SubmitFeedback'),
        id: 'Zuora/SubmitFeedback-popover',
        items: [
          {
            label: i18next.t('GlobalNav.Feedback.NewZuoraExperience'),
            id: 'Zuora/SubmitFeedback-popover-new-zuora-experience',
            noIcon: true,
            expandable: false,
            customEvent: 'new-zuora-experience-feedback',
          },
        ],
      },
    };
  }
}
